/**
 * Cliente HTTP da cadeia de custódia do caso (E58.F2 — ADR-0067). // ux-neutrality:allow doc-comment
 *
 * Espelha apps/api/types/cadeia_custodia.py. A tela lê a MESMA fonte que // ux-neutrality:allow doc-comment
 * alimenta o Apêndice B do laudo: uma tela que divergisse do documento // ux-neutrality:allow doc-comment
 * assinado seria pior que tela nenhuma. // ux-neutrality:allow doc-comment
 */
import type { AxiosInstance } from 'axios';

/** E80.F1 acrescentou `foto` no backend; a tela só a conheceu na E82.F7.T03. */
export type TipoPeca = 'documento' | 'assinatura' | 'foto';

export interface PecaCustodiada {
  id: string;
  tipo: TipoPeca;
  descricao: string;
  anexado_por: string;
  anexado_em: string;
  /** `null` em peça anterior ao registro de integridade — declarado, não omitido. */
  sha256: string | null;
  tamanho_bytes: number;
}

/** E85.F2 (GUS-32): o que o sistema PRODUZIU, na segunda lista do registro. */
export type TipoDocumentoRegistrado =
  | 'captura_da_mesa'
  | 'protocolo_importado'
  | 'laudo_certificado';

export interface DocumentoRegistrado {
  id: string;
  tipo: TipoDocumentoRegistrado;
  descricao: string;
  produzido_por: string;
  produzido_em: string;
  /** `null` só em captura anterior ao registro de integridade — declarado. */
  sha256: string | null;
}

export interface CadeiaCustodiaData {
  case_id: string;
  pecas: PecaCustodiada[];
  /** Ausente em resposta anterior à E85.F2: a tela trata como lista vazia. */
  documentos?: DocumentoRegistrado[];
}

export async function getCadeiaCustodia(
  client: AxiosInstance,
  caseId: string,
): Promise<CadeiaCustodiaData> {
  const { data } = await client.get<CadeiaCustodiaData>(`/casos/${caseId}/cadeia-custodia`);
  return data;
}

const DATA_HORA = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatarRecebimento(iso: string): string {
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? iso : DATA_HORA.format(data);
}

/**
 * Encurta o código para leitura na tela sem esconder o valor. // ux-neutrality:allow doc-comment
 *
 * O código inteiro continua acessível por cópia e é ele que sai no laudo — a // ux-neutrality:allow doc-comment
 * tela abrevia porque 64 caracteres numa célula quebram a tabela, não porque o // ux-neutrality:allow doc-comment
 * valor completo seja dispensável. // ux-neutrality:allow doc-comment
 */
export function abreviarCodigo(sha256: string): string {
  return `${sha256.slice(0, 12)}…${sha256.slice(-8)}`;
}
